import React ,{useEffect , useState} from 'react'
import {Link} from "react-router-dom"
// import OwlCarousel from 'react-owl-carousel';  
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";


import seoData from './dat';
import {Helmet} from "react-helmet";

import WhatshotIcon from '@material-ui/icons/Whatshot';

import Hero from "../components/Hero";
import BookCar from "../components/BookCar";
import Review from "../components/Review";
import PickCar from "../components/PickCar";
import Faq from "../components/Faq";

import swal from 'sweetalert';

import "react-responsive-carousel/lib/styles/carousel.min.css";

import Im1 from '../assets/images/im1.png';
import Im2 from '../assets/images/im2.png';


import sh1 from '../assets/images/short-term.png';
import mt1 from '../assets/images/monthly.png';
import we1 from '../assets/images/long-term.png';


import ch344 from '../assets/images/man-with-car.png';
import ch3444 from '../assets/images/support.png';
import ch34444 from '../assets/images/car-insurance.png';
import ch3444444 from '../assets/images/calendar.png';
import ch34444444 from '../assets/images/parking-area.png';

import Carousel11 from './Carosel0';



const Home = ( props ) => {
   
  const options = {
    // margin: 30,
    // responsiveClass: true,
    // nav: true,
    // dots: false,
    // autoplay: false,
    // navText: ["Prev", "Next"],
    // smartSpeed: 1000,
    responsive: {
        0: {
            items: 1,
        },
        400: {
            items: 1,
        },
        600: {
            items: 2,
        },
        700: {
            items: 4,
        },
        1600: {
            items: 4,

        }
    },
};
    const [product , setproduct] = useState([])
    const [dis , setdis] = useState(false)

    const [product1 , setproduct1] = useState([])
    const [product8 , setproduct8] = useState([])
    const [product9 , setproduct9] = useState([])
    const [product10 , setproduct10] = useState([])
    const [product11 , setproduct11] = useState([])
    const [AllPage , setAllPage] = useState([])

    // const [Product_Image_Upload , setProduct_Image_Upload] = useState("")
    

    useEffect(() =>{

        window.scrollTo(0, 0)
        setInterval(() => {
          if( document.getElementsByClassName("carousel-indicators")[0])
          document.getElementsByClassName("carousel-indicators")[0].remove()
        }, 1000);
        
        let url1 = props.match.params.url ;
        seoData.map((res,i)=>{
          if(res.url === url1){
              setAllPage([res])
          }
        })
      console.log(    document.getElementsByClassName("carousel-indicators")[0]
      )
        fetch("https://falcon-rides-main-back.vercel.app/AllProduct",{
       method: "GET",
        headers :  {
        "Content-Type" : "application/json" , 
    }
   })
   .then(res5=>res5.json())
   .then(res6=>{
    //    console.log(res6);
    const pro = []
    const pro1 = []
    const pro2 = []
    const pro3 = []
    res6.map((res7,i)=>{
        //    console.log(res7.Product_Popular );
        if ( res7.Arrival){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro.push(res7)
        }
        if ( res7.Arrival1){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro1.push(res7)
        }
        if ( res7.Arrival2){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro2.push(res7)
        }
        if ( res7.Arrival3){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro3.push(res7)
        }
    })
    // setproduct(pro.reverse())
    setproduct8(pro)
    setproduct9(pro1)
    setproduct10(pro2)
    setproduct11(pro3)
    setproduct(pro.slice(0,8))
    setproduct1(pro1.slice(0,8))
    localStorage.setItem("All1",JSON.stringify(res6))
    setdis(true)
   })
    
 },[])

 
   
    
    
    
    
        return (
            
          <div>


<Helmet>
                { AllPage[0] && AllPage[0].title   ?
                <title>{AllPage[0].title}</title>
                :""
                }
                { AllPage[0] && AllPage[0].url   ?
                <link rel="canonical" href={`https://dubai.falcon-rides.com/areas/${AllPage[0].url}`} />
                :""
                }
                { AllPage[0] && AllPage[0].text   ?
                <meta name="description" content={`${AllPage[0].text}`} />
                :""
            }
            <meta name="description" content="kjkjkkj iofgivion io i uoh ui h i hu ihui ui" data-react-helmet="true" />
                { AllPage[0] && AllPage[0].keyword   ?
                <meta name="keyword" content={AllPage[0].keyword} />
                :""
                }
            </Helmet>







<Hero/>



























          <div className="page-wrapper">
            
            {/* End .header */}
            <main className="main" style={{maxHeight:  '100%' , overflowX :  "hidden"}}>



            <div className="container deal-section">
                <h2 className="title text-center font-weight-bold mt-3" style={{fontSize: "25px"}}> Explore Dubai With Best <br/> Car Rental In Dubai Like Never Before!

</h2>

                <div className='row'>
            

<Carousel11/>

                       
<br/>
                <span onClick={()=>props.history.push("/categories/Cars/all-products")}  className="shadow-none" style={{borderRadius: "10px",
    minWidth: '275px',
    maxWidth: "350px",
    color: 'white',
    background: "rgb(150, 4, 14)",
    padding: "8px 46px",
    fontSize: "25px",
    fontWeight: 'bold',
    cursor: "pointer",
    margin: "auto",
    textTransform: "uppercase"
  }}>                Explore our fleet
                </span>
                </div>  

                {/* <buttonstyle={{width: "92%"}}>
                Explore our fleet
                </button> */}
              </div>

<br/>
<br/>



            <BookCar />


















            <div className="container banner-group-1">
               
               <div className='container' style={{background:"rgb(240, 240, 240)"}}>
                  {/* <div className='container' style={{backgroundImage: 'url('+ab+')',backgroundPosition: "center",
     backgroundRepeat: "no-repeat",
     backgroundSize: "cover",}}> */}
                   <br/>
              <h3 class="text-center">Our Flexible Car Rental Plans

 </h3>
            
                     <div class="row justify-content-center">
                         <div class="col-lg-6 col-sm-6">
                             <div class="icon-box text-center" style={{padding  :"30px 13px",borderRadius:"14px",borderBottom:"3px solid #96040e" ,height : "auto",color : "black", background : "white"}} >
                                 <span class="icon-box-icon" style={{padding: "0px 27px",
    display: "flex",
    justifyContent: "space-between" }}>
                                  <h3 class="icon-box-title cgg" style={{fontWeight : "600",fontSize : "22px",padding:"0px",margin:"0px"}}> Short Term
<br />
<span style={{color :"#96040e",fontSize:"15px"}}>

Car Rental
</span>

 
 </h3>      {/* <i class="icon-local_car_wash"></i> */}
                                     <img src={sh1} alt="" style={{height   : "40px"}}/>
                                 </span>
                                 <div class="icon-box-content">
                                  
                                     <p className="cgg">Are you trying to find a flexible rental car? Check out our many car hire options, available for both day and weekly rentals. Whether you need to go on a weekend getaway or do a quick errand, we have the ideal short-term car rental deals.


 
 
 
 </p>
                                 </div>
                             </div>
                         </div>
 
                         <div class="col-lg-3 col-sm-6">
                             <div class="icon-box text-center" style={{padding  :"30px 13px",borderRadius:"14px",borderBottom:"3px solid #96040e" ,height : "auto",color : "black", background : "white"}} >
                                                             <span class="icon-box-icon" style={{padding: "0px 27px",
    display: "flex",
    justifyContent: "space-between" }}>
 <h3 class="icon-box-title cgg" style={{fontWeight : "600",fontSize : "22px",padding:"0px",margin:"0px"}}>Monthly
                                     <br />
                                     
                                     <span style={{color :"#96040e",fontSize:"15px"}}>
 Car Rental
</span>
 </h3>
                             <img src={mt1} alt="" style={{height   : "40px"}}/>
 </span>
                                 <div class="icon-box-content">
                                     
                                     <p className="cgg" style={{}}>At Falcon Rides Car Rental, we offer monthly car hire services to both residents and tourists in the UAE, catering to all car rental requirements.


 </p>
                                 </div>
                             </div>
                         </div>
 
                         <div class="col-lg-3 col-sm-6">
                             <div class="icon-box text-center" style={{padding  :"30px 13px",borderRadius:"14px",borderBottom:"3px solid #96040e" ,height : "auto",color : "black", background : "white"}} >
                                                             <span class="icon-box-icon" style={{padding: "0px 27px",
    display: "flex",
    justifyContent: "space-between" }}>
  <h3 class="icon-box-title cgg" style={{fontWeight : "600",fontSize : "22px",padding:"0px",margin:"0px"}}> Long-Term
 
 <br />
 <span style={{color :"#96040e",fontSize:"15px"}}>

 Car Rental
</span>
 </h3>
                             <img src={we1} alt="" style={{height   : "40px"}}/>
 </span>
                                 <div class="icon-box-content">
                                    
                                     <p className="cgg">Our long term car lease plans provide comfortable travels within Dubai, whether you need a small city car or something more substantial.


 
 </p>
                                 </div>
                             </div>
                         </div>
 
                         
                         </div>
                     </div>
 </div>
 









            <br />
 
 <div className="container banner-group-1">



     <div className='container' style={{}}>
   
           <div class="row justify-content-center">
               <div class="col-lg-10 col-sm-10">
<h2 style={{fontSize: "29px",
fontWeight: "700"}}>Document Required to Hire a Car in Dubai</h2>
<p>When reserving a rent a car service, it is essential to have the required paperwork in order to guarantee that you will have the chance to see the stunning towns of the United Arab Emirates. We provide a simple and easy booking process that you may start simply completing the necessary paperwork. We kindly ask that you submit the required paperwork during the booking process.</p>
      </div>  
      </div>  
      <br />
           <div class="row justify-content-center">
               <div class="col-lg-6 col-sm-6">
                   <div class="icon-box text-center" style={{borderLeft: "3px solid rgb(241, 199, 199)",margin  :"5px 15px" ,padding  :"10px 13px" ,height : "200px",color : "black", background : "white",display: "flex",justifyContent: "center",
alignItems: "center"}} >
                       <div>
                          <span class="icon-box-icon" style={{padding  :"0px" , }}>
                            <img src={Im1} alt="" style={{height   : "100px"}}/>
                        </span>
                       </div>
                       <div class="icon-box-content"  style={{paddingLeft:"30px"}}>
                           <h3 class="icon-box-title cgg" style={{fontWeight : "600",fontSize : "20px"}}> In The Case Of Visitors To The UAE

                            </h3>
                           <p className="cgg" style={{textAlign :"left",paddingBottom:"12px",fontSize:"1.2rem"}}>⭕ Copy of passport.
                          </p>
                           <p className="cgg" style={{textAlign :"left",paddingBottom:"12px",fontSize:"1.2rem"}}>⭕ A legitimate driver's license from abroad

                          </p>
                           <p className="cgg" style={{textAlign :"left",paddingBottom:"12px",fontSize:"1.2rem"}}>⭕ Copy of Visit Visa or Stamped Visa
                           .
                          </p>
                       </div>
                   </div>
               </div>
               <div class="col-lg-6 col-sm-6">
                   <div class="icon-box text-center" style={{borderLeft: "3px solid rgb(241, 199, 199)",margin  :"5px 15px" ,padding  :"10px 13px" ,height : "200px",color : "black", background : "white",display: "flex",justifyContent: "center",
alignItems: "center"}} >
                       <div>
                          <span class="icon-box-icon" style={{padding  :"0px" , }}>
                            <img src={Im2} alt="" style={{height   : "111px",objectFit:"cover"}}/>
                        </span>
                       </div>
                       <div class="icon-box-content" style={{paddingLeft:"30px"}}>
                           <h3 class="icon-box-title cgg" style={{fontWeight : "600",fontSize : "20px"}}> For Citizens Of The United Arab Emirates


                            </h3>
                           <p className="cgg" style={{textAlign :"left",paddingBottom:"12px",fontSize:"1.2rem"}}>⭕ Copy of passport.
                          </p>
                           <p className="cgg" style={{textAlign :"left",paddingBottom:"12px",fontSize:"1.2rem"}}>⭕ A current UAE driver's license


                          </p>
                           <p className="cgg" style={{textAlign :"left",paddingBottom:"12px",fontSize:"1.2rem"}}>⭕ A copy of the Emirates ID

                          </p>
                       </div>
                   </div>
               </div>

               
               
               </div>
           </div>
</div>








           <br/>  
           <PickCar />


           <div className="container banner-group-1">
               
               <div className='container' style={{background:"rgb(240, 240, 240)"}}>
               
                   <br/>
              <p class="text-center">AFFORDABLE CARS IN Dubai
 
 
 </p>
              <h2 class="title mb-4 text-center" style={{width: "auto"}}>Why <b>falcon-rides.com?</b> 
 
 </h2>
                     <div class="row justify-content-center">
                         <div class="col-lg-4 col-sm-6">
                             <div class="icon-box text-center" style={{padding  :"30px 13px" ,height : "200px",color : "black", background : "white"}} >
                                 <span class="icon-box-icon" style={{padding  :"0px" , }}>
                                     {/* <i class="icon-local_car_wash"></i> */}
                                     <img src={ch344} alt="" style={{height   : "40px"}}/>
                                 </span>
                                 <div class="icon-box-content">
                                     <h3 class="icon-box-title cgg" style={{fontWeight : "600",fontSize : "22px"}}> First Class Service
 
 </h3>
                                     <p className="cgg">Experience first-class service that surpasses expectations.
 
 
 
 </p>
                                 </div>
                             </div>
                         </div>
 
                         <div class="col-lg-4 col-sm-6">
                             <div class="icon-box text-center" style={{padding  :"30px 13px" ,height : "200px",color : "black", background : "white"}} >
                                                             <span class="icon-box-icon" style={{padding  :"0px" , }}>
 
                             <img src={ch3444} alt="" style={{height   : "40px"}}/>
 </span>
                                 <div class="icon-box-content">
                                     <h3 class="icon-box-title cgg" style={{fontWeight : "600",fontSize : "22px"}}>24/7 Customer <br /> Support
 </h3>
                                     <p className="cgg" style={{}}>Call us Anywhere Anytime
 </p>
                                 </div>
                             </div>
                         </div>
 
                         <div class="col-lg-4 col-sm-6">
                             <div class="icon-box text-center" style={{padding  :"30px 13px" ,height : "200px",color : "black", background : "white"}} >
                                                             <span class="icon-box-icon" style={{padding  :"0px" , }}>
 
                             <img src={ch34444} alt="" style={{height   : "40px"}}/>
 </span>
                                 <div class="icon-box-content">
                                     <h3 class="icon-box-title cgg" style={{fontWeight : "600",fontSize : "22px"}}> Clean and safe car
 </h3>
                                     <p className="cgg">Efficient safety and cleanliness checks
 
 </p>
                                 </div>
                             </div>
                         </div>
 
                         <div class="col-lg-4 col-sm-6">
                             <div class="icon-box text-center" style={{padding  :"30px 13px" ,height : "200px",color : "black", background : "white"}} >
                                                             <span class="icon-box-icon" style={{padding  :"0px" , }}>
 
                             <img src={ch3444444} alt="" style={{height   : "40px"}}/>
 </span>
                                 <div class="icon-box-content">
                                     <h3 class="icon-box-title cgg" style={{fontWeight : "600",fontSize : "22px"}}>Reservation Anytime  
 </h3>
                                     <p className="cgg">24/7 Online Reservation
 
 
 
 
 </p>
                                 </div>
                             </div>
                         </div>
                         <div class="col-lg-4 col-sm-6">
                             <div class="icon-box text-center" style={{padding  :"30px 13px" ,height : "200px",color : "black", background : "white"}} >
                                                             <span class="icon-box-icon" style={{padding  :"0px" , }}>
 
                             <WhatshotIcon alt="" style={{height   : "40px",color : "black",fontSize:"60px"}}/>
 </span>
                                 <div class="icon-box-content">
                                     <h3 class="icon-box-title cgg" style={{fontWeight : "600",fontSize : "22px"}}>Quality at Minimum Expense
  
 </h3>
                                     <p className="cgg">Delivering quality at a Minimum Spend.
 
 
 
 
 </p>
                                 </div>
                             </div>
                         </div>
                         <div class="col-lg-4 col-sm-6">
                             <div class="icon-box text-center" style={{padding  :"30px 13px" ,height : "200px",color : "black", background : "white"}} >
                                                             <span class="icon-box-icon" style={{padding  :"0px" , }}>
 
                             <img src={ch34444444} alt="" style={{height   : "40px"}}/>
 </span>
                                 <div class="icon-box-content">
                                     <h3 class="icon-box-title cgg" style={{fontWeight : "600",fontSize : "22px"}}>Free Pick-Up & Drop-Off
 
  
 </h3>
                                     <p className="cgg">Enjoy complimentary pick-up and drop-off services.
 
 
 
 
 </p>
                                 </div>
                             </div>
                         </div>
                     </div>
 </div>
 






<div className='container' style={{background :  "#96040e"}}>
          
          <div class="row justify-content-center">
              <div class="col-lg-3 col-sm-6">
                  <div class="icon-box text-center" style={{padding  :"30px 13px" ,height : "100px",justifyContent  : "center",color : "white", background : "#96040e" , display : "flex"}} >

                  <img src={ch34444} alt="" style={{height   : "40px"}}/>

                      <div class="icon-box-content" style={{paddingLeft:  "20px"}}>
                          <h3 class="icon-box-title cgg1" style={{fontWeight : "600",fontSize : "22px" , margin : "0px",padding  :  "0px"}}>50+ 
</h3>
                          <p className="cgg1" style={{}}>NO. OF CARS

</p>
                      </div>
                  </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                  <div class="icon-box text-center" style={{padding  :"30px 13px" ,height : "100px",justifyContent  : "center",color : "white", background : "#96040e" , display : "flex"}} >
                          {/* <i class="icon-local_car_wash"></i> */}
                          <img src={ch344} alt="" style={{height   : "40px"}}/>
                    
                      <div class="icon-box-content" style={{paddingLeft:  "20px"}}>
                          <h3 class="icon-box-title cgg1" style={{fontWeight : "600",fontSize : "22px" , margin : "0px",padding  :  "0px"}}> 5,000+

</h3>
                          <p className="cgg1">HAPPY CUSTOMERS




</p>
                      </div>
                  </div>
              </div>


              <div class="col-lg-3 col-sm-6">
                  <div class="icon-box text-center" style={{padding  :"30px 13px" ,height : "100px",justifyContent  : "center",color : "white", background : "#96040e" , display : "flex"}} >

                  <img src={ch34444444} alt="" style={{height   : "40px"}}/>
                      <div class="icon-box-content" style={{paddingLeft:  "20px"}}>
                          <h3 class="icon-box-title cgg1" style={{fontWeight : "600",fontSize : "22px" , margin : "0px",padding  :  "0px"}}> 6
</h3>
                          <p className="cgg1">Operate In Locations

</p>
                      </div>
                  </div>
              </div>
              
              <div class="col-lg-3 col-sm-6">
                  <div class="icon-box text-center" style={{padding  :"30px 13px" ,height : "100px",justifyContent  : "center",color : "white", background : "#96040e" , display : "flex"}} >

                  <img src={ch3444} alt="" style={{height   : "40px"}}/>
                      <div class="icon-box-content" style={{paddingLeft:  "20px"}}>
                          <h3 class="icon-box-title cgg1" style={{fontWeight : "600",fontSize : "22px" , margin : "0px",padding  :  "0px"}}> 24/7
</h3>
                          <p className="cgg1">Quality Support

</p>
                      </div>
                  </div>
              </div>
              
          </div>
</div>

<br />



<Review />




<section className="plan-section">
        <div className="container">
          <div className="plan-container">
            <div className="plan-container__title">
              <h2>Service Areas</h2>
            </div>

         








             
             
          </div>
        </div>
      </section>







            <hr className="mt-2 mb-0" />
              </div>
              <br />



        
      <Faq/>     
<br />
<div className='container' style={{margin : "30px 10px"}}>
            <div className='row'  >
            <div className="col-10 col-lg-10  col-sm-12" style={{margin  :"auto"}}>
 
            <h1>{ AllPage[0] && AllPage[0].title }
                 </h1>
 
                
                 <p style={{maxWidth : "100%"}}> {AllPage[0] &&AllPage[0].text ?<div dangerouslySetInnerHTML={{__html: AllPage[0].text}} />:""}</p> 


                 <br/>
                 <p style={{color : "black",fontWeight:"800"}}>Keyowrd : { AllPage[0] && AllPage[0].keyword}</p>

     
            </div>
            </div>
            </div>



              
              {/* End .blog-posts */}
            </main>
            
            {/* End .footer */}
          </div>
          <button id="scroll-top" title="Back to Top">
            <i className="icon-arrow-up" />
          </button>
       
        </div>
        )
    
}

export default Home;